import { AuscultationInformation } from '../stores/auscultation-info.store';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';

export const AuscultationDataTypesEnum = {
  CHOICE_LIST: 1,
  TEXT: 2,
  DOCUMENT: 3,
  PHOTOS: 4,
} as const;

export const AuscultationDataTypes = [
  { value: AuscultationDataTypesEnum.CHOICE_LIST, labelKey: 'entities.auscultationInformation.dataTypes.choiceList' },
  { value: AuscultationDataTypesEnum.TEXT, labelKey: 'entities.auscultationInformation.dataTypes.text' },
  { value: AuscultationDataTypesEnum.DOCUMENT, labelKey: 'entities.auscultationInformation.dataTypes.document' },
  { value: AuscultationDataTypesEnum.PHOTOS, labelKey: 'entities.auscultationInformation.dataTypes.photos' },
];

export const AuscultationInformationDefinition: EntityDefinition<AuscultationInformation> = {
  entityType: 'AuscultationInformation',
  i18nBase: 'entities.auscultationInformation',
  enableFiltering: true,
  list: {
    columns: [
      { field: 'name', headerKey: 'entities.auscultationInformation.fields.name', sortable: true, filterable: true },
      {
        field: 'type',
        headerKey: 'entities.auscultationInformation.fields.type',
        template: 'optionValue',
        options: [...AuscultationDataTypes],
        sortable: true,
        filterable: 'multiselect',
      },
    ],
  },
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: AuscultationInformation) => !entity.isUsed,
      errorMessageKey: 'entities.auscultationInformation.messages.deleteError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.auscultationInformation.messages.createTitle',
      edit: () => 'entities.auscultationInformation.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.auscultationInformation.messages.addButton',
      create: () => 'entities.auscultationInformation.messages.addButton',
      edit: () => 'entities.auscultationInformation.messages.editTitleWithName',
      delete: () => 'entities.auscultationInformation.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.auscultationInformation.messages.deleteConfirm',
  },
};
